/*!
 * Googlemap Class
 */
(() => {
	const INSTANCES = []

	class GoogleMap {
		/**
         * Represents a GoogleMap.
         * @constructor
         * @param {string} id - id of element where schould by display Googlemap module.
         * @param {object} params - json with module configuration.
         */
		constructor (id, params) {
			INSTANCES.push(this)
			this.id = id
			this.params = params
			this.markers = []
			document.addEventListener('DOMContentLoaded', this.init.bind(this))
		}

		static get INSTANCES () {
			return INSTANCES
		}

		/**
         * initialize a GoogleMap.
         *
         */
		init () {
			this.container = document.getElementById(this.id)

			this.mapBlock = this.container.querySelector('[data-googlemap="map"]')
			if (this.mapBlock !== undefined && this.mapBlock !== null) {
				this._map = new google.maps.Map(this.mapBlock, this.getOptions())
				this._map.panBy(...this.getPan())
				this.createMarker()
			}
			if (this.params.gmapRouteType === 'route') { this.bindRouteRedirect() }
		}

		/**
         * Create map options.
        * @return {object} Google map params object
         */
		getOptions () {
			return {
				center: {
					lat: parseFloat(this.params.gmapLat),
					lng: parseFloat(this.params.gmapLng)
				},
				zoom: parseInt(this.params.gmapZoom),
				styles: this.getStyles(),
				mapTypeId: this.params.gmapMapType.toLowerCase(),
				gestureHandling: this.params.gmapScroll ? 'greedy' : 'cooperative'
			}
		}

		/**
         * Create pin options.
         *
         * @return {array} array with vector
         */
		getPan () {
			const vertical = parseInt(this.params.gmapVerticalMove)
			const horizontal = parseInt(this.params.gmapHorizontalMove)

			return [
				isNaN(vertical) ? 0 : -vertical,
				isNaN(horizontal) ? 0 : horizontal
			]
		}

		/**
         * Get map object style.
         *
         * @return {object} Google map style object
         */
		getStyles () {
			try {
				return JSON.parse(this.params.gmapStyleCode)
			} catch (e) {
				return []
			}
		}

		/**
         * Create Marker and inject to exist map object.
         * @param {object} params - json with module configuration.
         */
		createMarker (params = {}) {
			const position = params.position || this.getOptions().center

			const options = {
				map: this._map,
				position
			}

			if (this.params.gmapImg !== '') { options.icon = this.params.gmapImg }

			const marker = new google.maps.Marker(options)

			let infoWindow
			if (this.params.gmapText !== '') {
				infoWindow = this.getInfoWindow(this.params.gmapText)
				marker.addListener('click', () => {
					infoWindow.open(this._map, marker)
				})
				if (this.params.hasOwnProperty('gmapInfoWindowOpen')) {
					infoWindow.open(this._map, marker)
				}
			}
		}

		/**
         * Create url to google map with given in params location.
         *
         * * @return {string} Google map url
         */
		getRouteUrl (destination) {
			return `https://www.google.com/maps/dir/${destination}/${this.params.gmapPlaceId}`
		}

		/**
         * Find all action button for module then procced to binding.
         *
         */
		bindRouteRedirect () {
			let button = this.container.querySelector('[data-googlemap="button"]')
			this.input = this.container.querySelector('[data-googlemap="input"]')
			this.registerPlaneRouteButton(button)
		}

		/**
         * Bind to all button redirect method.
         *
         */
		registerPlaneRouteButton (button) {
			button.addEventListener('click', this.redirect.bind(this))
		}

		/**
         * Create and redirect for User to google map with data that allow google map to create path * between user location and location given in module params.
         *
         */
		redirect () {
			const destination = this.input.value.replace(' ', '+')
			const url = this.getRouteUrl(destination)
			if (destination.length !== 0) { window.open(url, '_blank') }
		}

		/**
         * create googlemap infowindow with text.
         *
         * @returns {object}  Googlemaps infowindow object.
         */
		getInfoWindow (content) {
			return new google.maps.InfoWindow({
				content
			})
		}
	}

	if (window.GoogleMap === undefined) { window.GoogleMap = GoogleMap } else { throw new Error('Class GoogleMap already exists.') }
})()

jQuery(function ($) {
	$('[data-toggle="tooltip"]').tooltip()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googlemap/script.js